import * as React from 'react';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import strings from 'owa-strings/owa-mail-strings';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { getIconCSSForFileProvider } from 'owa-fileprovider-icon';
import { observer } from 'mobx-react';

const styles = require('./FileProviderView.scss');

export interface FileProviderViewProps {
    providerType: AttachmentDataProviderType;
    providerName: string;
    onRemoveClicked?: () => void;
    displayText?: string;
}

@observer
export default class FileProviderView extends React.Component<FileProviderViewProps, {}> {
    render() {
        const { providerType, providerName, displayText, onRemoveClicked } = this.props;

        const containerStyle = onRemoveClicked ? styles.bigContainer : styles.smallContainer;
        const icon = getIconCSSForFileProvider(providerType);

        return (
            <div className={containerStyle}>
                <div className={styles.iconContainer}>{icon}</div>

                <div className={styles.contentContainer}>
                    <div className={styles.textContainer}>
                        <div className={styles.displayText}>{displayText}</div>
                        <div className={styles.providerName}>{providerName}</div>
                    </div>
                    {onRemoveClicked && (
                        <div className={styles.actions}>
                            <DefaultButton onClick={onRemoveClicked}>
                                {strings.FilePickerOptions_Remove}
                            </DefaultButton>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
